import api from "../../config/client.axios.api";

export const getAllMachineApiRequest = async () => {
  const response = await api.get(`/machine`);
  return response.data;
};
